export const isNotLastItem = <T>(index: number, array: T[]): boolean => {
  return index < array.length - 1;
};
